export enum InfluencerLandingPageEvent {
  PageView = 'user.event_user_view_landingpage',
  FollowClosetCtaClick = 'user.event_user_landingspage_follow_closet',
  ListItemCtaClick = 'user.event_user_landingpage_create_listing',
  ProductCardClick = 'user.event_user_landingpage_product_click',
}

export const InfluencerLandingPagePopulateParams = [
  'seo.og_image',
  'introduction_section.image_mobile',
  'introduction_section.image_mobile_2x',
  'introduction_section.image_mobile_3x',
  'introduction_section.image',
  'introduction_section.image_2x',
  'introduction_section.image_3x',
  'introduction_section.image_wide',
  'introduction_section.image_wide_2x',
  'introduction_section.image_wide_3x',
  'lifestyle_section.cards.image',
  'lifestyle_section.cards.image_2x',
  'lifestyle_section.cards.image_3x',
  'closet_section.product_list',
  'tips_section.cards.image',
  'tips_section.cards.image_2x',
  'tips_section.cards.image_3x',
  'inspiration_section.inspiration_product_list',
  'disclaimer_section',
]
